<!--
SPDX-FileCopyrightText: 2025 Land Baden-Württemberg <InnoLab@stm.bwl.de>

SPDX-License-Identifier: MPL-2.0
-->

<script>
import { onDestroy, onMount } from "svelte";
import Dropzone from "svelte-file-dropzone";
import uiStore from "../utils/UIStore";

export let isDropzoneActive = false;
export let addFiles = () => console.log("No function defined");

let uiTexts;
uiStore.textStore.subscribe((store) => {
	uiTexts = store.texts;
});

onMount(() => {
	window.addEventListener("dragenter", handleDragEnterWindow);
	window.addEventListener("dragend", handleDragLeaveWindow);
});

onDestroy(() => {
	window.removeEventListener("dragenter", handleDragEnterWindow);
	window.removeEventListener("dragend", handleDragLeaveWindow);
});

//---functions for Drag and Drop
const handleDragEnterWindow = (event) => {
	event.preventDefault();
	isDropzoneActive = true;
};
const handleDragLeaveWindow = (event) => {
	event.preventDefault();
	isDropzoneActive = false;
};
const handleDragEnterDropzone = (event) => {
	event.preventDefault();
	isDropzoneActive = true;
	window.removeEventListener("dragenter", handleDragEnterWindow);
};
const handleDragLeaveDropzone = (event) => {
	event.preventDefault();
	isDropzoneActive = false;
	setTimeout(
		() => window.addEventListener("dragenter", handleDragEnterWindow),
		200,
	);
};
function handleFilesSelectInDropzone(e) {
	isDropzoneActive = false;
	window.addEventListener("dragenter", handleDragEnterWindow);

	const files = {
		accepted: [],
		rejected: [],
	};
	const { acceptedFiles, fileRejections } = e.detail;
	files.accepted = [...files.accepted, ...acceptedFiles];
	files.rejected = [...files.rejected, ...fileRejections];

	addFiles(files.accepted);
}
</script>

{#if isDropzoneActive}
  <div class="dropzone-container {isDropzoneActive ? 'active' : ''}">
    <Dropzone
      disabled={!isDropzoneActive}
      on:drop={handleFilesSelectInDropzone}
      on:dragleave={handleDragLeaveDropzone}
      on:dragenter={handleDragEnterDropzone}
      accept=".doc, .docx, application/msword, .pdf, .txt"
      containerStyles="flex:none; display:flex; flex-direction: column; justify-content: space-around; padding: 10px 10px 10px 10px; width: 90%; height: 75%; border: 2px dashed rgb(189, 189, 189); background-color: white"
    >
      <div>
        <p>{uiTexts.dragAndDrop.dropFilesHere}</p>
        <p>{uiTexts.dragAndDrop.allowedFormats}</p>
      </div>
    </Dropzone>
  </div>
{/if}

<style>
  .dropzone-container {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    font-size: 2rem;
    z-index: 11;
  }

  .dropzone-container p {
    font-size: 1.3rem;
  }
</style>
